export default function globalInitSlick() {
  $('.ad-image').slick({
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    infinite: false,
    dots: true,
    autoplay: false,
    prevArrow: '<a class=\'arrows prev\'><i class=\'fa fa-angle-left\'></i></a>',
    nextArrow: '<a class=\'arrows next\'><i class=\'fa fa-angle-right\'></i></a>',
    customPaging() {
      return `<span class='dot'></a>`;
    },
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false
        }
      }
    ]
  });
}



// WEBPACK FOOTER //
// ./app/webpacker/src/js/modules/global_init_slick.js